import api from "../../utils/api";
import {setBottomBarError} from "../../utils/Functions";
import {useEffect, useState} from "react";
import {useAppContext} from "../../context/Context";

export default function useScalewayRateLimitsCard() {
    const [, dispatch] = useAppContext();

    const [requestPerMinutes, setRequestsPerMinutes] = useState([]);
    const [tokensPerMinutes, setTokensPerMinutes] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const rateLimits = await api.get(`/company/all/ratelimits`);
                const responseRateLimitsObject = rateLimits.data;
                setTokensPerMinutes([responseRateLimitsObject.tei_tokens, responseRateLimitsObject.completions_tokens]);
                setRequestsPerMinutes([responseRateLimitsObject.tei_requests, responseRateLimitsObject.completions_requests]);
            } catch (error) {
                console.error(error);
                setBottomBarError(dispatch, error);

            }
        })().catch(console.error);
    }, [dispatch]);

    return {requestPerMinutes, tokensPerMinutes};
}